import { render, staticRenderFns } from "./DatabaseGeneList.vue?vue&type=template&id=6fd57576&"
import script from "./DatabaseGeneList.vue?vue&type=script&lang=js&"
export * from "./DatabaseGeneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports